// extracted by mini-css-extract-plugin
module.exports = {"slider":"slider-module__slider___35I-N"};